module.exports = __webpack_public_path__ + "media/team_admin/download-ce054c54.svg";